export enum FormaPagamentoEnum {

  e1 = "Dinheiro",
  e2 = "Cheque",
  e3 = "N�o identificado"
}
